import React from 'react';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { UpcomingAlert } from '../../domaine/dashboardModel';

interface UpcomingAlertsTableProps {
  data: UpcomingAlert[] | undefined;
}

const UpcomingAlertsTable: React.FC<UpcomingAlertsTableProps> = ({ data }) => {
  const columns: ColumnsType<UpcomingAlert> = [
    {
      title: 'Date de l\'alerte',
      dataIndex: 'alerte_date',
      key: 'alerte_date',
      render: (date: Date) => new Date(date).toLocaleDateString(), // Format the date
      onHeaderCell: () => ({
        style: {
          textAlign: "center",
          color: "#fff",
          backgroundColor: "#42005a",
        },
      }),
    },
    {
      title: 'Project',
      dataIndex: 'projet',
      key: 'projet',
      onHeaderCell: () => ({
        style: {
          textAlign: "center",
          color: "#fff",
          backgroundColor: "#42005a",
        },
      }),
    },
    {
      title: 'Tranche',
      dataIndex: 'tranche',
      key: 'tranche',
      onHeaderCell: () => ({
        style: {
          textAlign: "center",
          color: "#fff",
          backgroundColor: "#42005a",
        },
      }),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      rowKey="id"
      pagination={false} // Disable pagination if not needed
      bordered
      size="small"
    />
  );
};

export default UpcomingAlertsTable;